import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../theme/color-palette';
const { GREY, LIGHT_GRAY_SHADE } = colors;

const renderWeeksStyle = makeStyles(() => ({
	flexCol: {
		flexDirection: 'column',
		display: 'flex',
	},
	dayHeader: {
		width: 350 / 10,
		height: 280 / 10,
		color: GREY,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: LIGHT_GRAY_SHADE,
		fontSize: 12,
		fontWeight: 'bold',
		padding: 2,
		margin: 0.5,
	},
	block: {
		width: 350 / 10,
		height: 280 / 10,
		color: '#333333',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: '#ffffff',
		fontSize: 12,
		fontWeight: 'bold',
		padding: 2,
		margin: 0.5,
	},
	dayBg: {
		backgroundColor: '#EBE8F3',
	},
	weekBgBorderStart: {
		borderTopLeftRadius: 25,
		borderTopRightRadius: 25,
	},
	weekBgBorderEnd: {
		borderBottomLeftRadius: 25,
		borderBottomRightRadius: 25,
	},
	range: {
		color: '#ffffff',
		backgroundColor: '#3c228a',
		borderRadius: 25,
	},
	daySelected: {
		backgroundColor: '#EBE8F3',
	},
	weekHighlight: {
		backgroundColor: 'var(--f-2-f-2-f-2, #F2F2F2)',
	},
	weekHighlightHover: {
		'&:hover': {
			backgroundColor: '#DADCE0',
			borderRadius: '50%',
		},
	},
	dayTransparent: {
		backgroundColor: 'transparent',
	},
	disabled: {
		color: '#B2B0B9',
	},
	dftCursor: {
		cursor: 'default',
	},
	pointerCursor: {
		cursor: 'pointer',
	},
}));

export default renderWeeksStyle;
